import http from "./Http";

const obtenerUsers = async (skip = 0, limit = 25) => {
  const response = await http.get("/usuarios/", {
    params: { skip, limit },
  });
  return response.data;
};

const obtenerUsersConInstituciones = async (params = {}) => {
  const response = await http.get("/usuarios/instituciones", {
    params,
  });
  return response.data;
};

const crearUsuarioBase = async ({ dni, nombres, apellidos, is_admin = false }) => {
  const payload = {
    id: dni,
    nombres,
    apellidos,
    is_admin,
  };

  const response = await http.post("/usuarios/", payload);
  return response.data;
};

const actualizarUsuario = async (usuario_id, data) => {
  const response = await http.patch(`/usuarios/${usuario_id}`, data);
  return response.data;
};

const eliminarUsuario = async (usuario_id) => {
  const response = await http.delete(`/usuarios/${usuario_id}`);
  return response.data;
};

const resetearPasswordUsuario = async (usuario_id) => {
  const response = await http.post(`/usuarios/${usuario_id}/reset-password`);
  return response.data;
};

const vincularUsuarioInstitucion = async ({ usuario_id, institucion_id, rol_id }) => {
  const payload = {
    usuario_id,
    institucion_id,
    rol_id,
  };

  const response = await http.post("/usuarios/vinculos", payload);
  return response.data;
};

const actualizarVinculoUsuarioInstitucion = async (
  usuario_id,
  institucion_id,
  data
) => {
  const response = await http.patch(
    `/usuarios/vinculos/${usuario_id}/${institucion_id}`,
    data
  );
  return response.data;
};

const desvincularUsuarioInstitucion = async (usuario_id, institucion_id) => {
  const response = await http.delete(
    `/usuarios/vinculos/${usuario_id}/${institucion_id}`
  );
  return response.data;
};

const UsersService = {
  obtenerUsers,
  obtenerUsersConInstituciones,
  crearUsuarioBase,
  eliminarUsuario,
  resetearPasswordUsuario,
  vincularUsuarioInstitucion,
  actualizarVinculoUsuarioInstitucion,
  desvincularUsuarioInstitucion,
  actualizarUsuario,
};

export default UsersService;
